module.exports = __webpack_public_path__ + "static/media/PlaceholderStoryImage.084d077b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PlaceholderStoryImage.png
// module id = 334
// module chunks = 0